import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: { userName: null, userId: null, token: null, avatar: null },
  reducers: {
    setCredentials: (state, action) => {
      const checked = localStorage.getItem('checked');
      state.userName = action.payload.userName;
      state.userId = action.payload._id;
      state.externalId = action.payload.externalId;
      state.token = action.payload.token;
      state.avatar = action.payload.avatar;
      if (checked === 'true') {
        localStorage.setItem(
          'user',
          JSON.stringify({
            userName: action.payload.userName,
            token: action.payload.token,
          })
        );
      } else {
        sessionStorage.setItem(
          'user',
          JSON.stringify({
            userName: action.payload.userName,
            token: action.payload.token,
          })
        );
      }
    },
    logOut: (state, action) => {
      state.userName = null;
      state.token = null;
      state.userId = null;
      state.avatar = null;
      state.externalId = null;
      sessionStorage.removeItem('user');
      localStorage.removeItem('user');
      localStorage.removeItem('checked');
      localStorage.removeItem('role');
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;
export const selectUser = (state) => state.auth.userId;
export const selectAvatar = (state) => state.auth.avatar;
export const selectexternalId = (state) => state.auth.externalId;
export default authSlice.reducer;
